import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"
import { FeedbackType } from "shared/types/FeedbackType"

import { useFeedback } from "features/feedback/model/useFeedback"

export function useFeedbackActionsOverlayModel() {
  const { closeOverlay } = useCurrentOverlay()
  const { openFeedbackOverlay } = useFeedback()

  const handleOpenFeedbackMessageOverlay = useEvent(
    (feedbackType: FeedbackType) => {
      closeOverlay()
      openFeedbackOverlay({ feedbackType })
    }
  )

  return {
    onOpenFeedbackMessageOverlay: handleOpenFeedbackMessageOverlay,
    onClose: closeOverlay
  }
}
